import React from 'react';

import { observer } from 'mobx-react';

import { colors } from 'theme/colors';
import withGoogMaps from 'ui/Map/withGoogleMaps';
import Map from 'ui/Map';
import BreadCrumbs from 'ui/Map/BreadCrumbs';
import RoundMarker from 'ui/Map/RoundMarker/RoundMarker';

import { env } from 'config';

import MapControls from './components/MapControls';

import { Location, UuidableLocation } from '../../../../utils/stores/LocationHistory/types';
import { PersonalMapProps } from './types';

const MapComponentWithLoader = withGoogMaps(Map, env.REACT_APP_GOOGLE_MAPS_API_KEY as unknown as string);

const PersonalMap: React.FunctionComponent<PersonalMapProps> = ({
  position,
  icon,
  locationHistory,
  toolTip,
  mapStyle,
  roundColor,
}) => {
  const [moved, setMoved] = React.useState(false);

  return (
    <MapComponentWithLoader
      aria-label="personal-map"
      radius={120}
      center={moved ? undefined : position}
      onDrag={() => setMoved(true)}
      mapContainerStyle={{
        minWidth: 200,
        minHeight: 200,
        borderRadius: 8,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: colors.ui.border.main,
        ...mapStyle,
      }}
    >
      <RoundMarker
        icon={icon}
        roundColor={roundColor || colors.primary.main}
        location={position as Location}
        open={toolTip ? undefined : false}
        tooltipTitle={toolTip || ''}
      />

      {Boolean(locationHistory) && <BreadCrumbs path={locationHistory as UuidableLocation[]} />}
      <MapControls position={position as Location} />
    </MapComponentWithLoader>
  );
};

export default observer(PersonalMap);
